import { observer } from "mobx-react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import parse from 'html-react-parser';
import { BackButton, Button, Header, PageTitle } from "../../_ui";
import labels from '../../../_translations/profile.json';
import store from "../../../_services/store";
import { ReactComponent as FrFlag } from '../../../assets/svg/flags/fr.svg';
import { ReactComponent as EnFlag } from '../../../assets/svg/flags/en.svg';
import { ReactComponent as EsFlag } from '../../../assets/svg/flags/es.svg';
import { ReactComponent as ItFlag } from '../../../assets/svg/flags/it.svg';
import { ReactComponent as EditIcon } from '../../../assets/svg/edit.svg';
import { ReactComponent as LogoUser } from '../../../assets/svg/user.svg';

import { COLORS } from "../../../constants";
import {
  FlagContainer,
  EditIconContainer,
  ColumnContainer,
  LabelValueContainer,
  Label,
  Value,
  LanguageContainer,
  FlagsContainer,
  MainContainer,
  ProfessionContainer,
  AvatarContainer
} from "./components";
import { ROUTES } from "../../../router/routes";



const flags: TFlag[] = [
  {
    key: 'fr',
    element: <FrFlag />
  },
  {
    key: 'en',
    element: <EnFlag />
  },
  {
    key: 'es',
    element: <EsFlag />
  },
  {
    key: 'it',
    element: <ItFlag />
  }
];

const ProfilePage = observer(() => {
  const navigate = useNavigate();
  const user = store.user;

  const signOut = () => {
    store.logoutProfile();
    // Définit d'abord l'URL
    window.location.href = ROUTES.LOGIN();
    // Force le rechargement
    window.location.reload();
    console.log("signed out");
  }

  const editUser = () => {
    //window.location.assign(pfidUpdateAccountUrl)
  }

  const selectLanguage = (lang: Lang) => {
    store.setCurrentLanguage(lang);
  }

  useEffect(() => {

  }, [store.currentLanguage]);

  const flagItems = flags.map(flag => <FlagContainer key={flag.key} onClick={() => selectLanguage(flag.key)}>{flag.element}</FlagContainer>);
  const lastName = parse(`<bold>${user?.last_name}</bold>`)

  return (
    <div className="fadeIn">
      <Header bgUrl={"/images/bg-informations.jpeg"}>
        <PageTitle>{labels[store.currentLanguage].title}</PageTitle>

        <AvatarContainer>
          <LogoUser width={40} height={40} style={{ borderRadius: '50%' }} fill={COLORS.PRIMARY} />
        </AvatarContainer>

        <EditIconContainer onClick={editUser}>
          <EditIcon />
        </EditIconContainer>

        <ProfessionContainer>
          <Value style={{ margin: 0 }} >{user?.profession}</Value>
        </ProfessionContainer>
        <div style={{ display: 'flex', flexDirection: 'row', gap: '5px' }}>
          <Value style={{ color: COLORS.WHITE, fontWeight: 400 }}>{user?.first_name}</Value>
          <Value style={{ color: COLORS.WHITE, fontWeight: 700 }}>{user?.last_name}</Value>
        </div>

      </Header>

      {/* @ts-ignore */}
      <MainContainer>
        <ColumnContainer>
          <LabelValueContainer>
            <Label>{labels[store.currentLanguage].form.professionalid}</Label>
            <Value>{user?.professionalid}</Value>
          </LabelValueContainer>
          <LabelValueContainer>
            <Label>{labels[store.currentLanguage].form.theseyear}</Label>
            <Value>{user?.year}</Value>
          </LabelValueContainer>
        </ColumnContainer>

        <ColumnContainer>
          <LabelValueContainer>
            <Label>{labels[store.currentLanguage].form.email}</Label>
            <Value>{user?.email}</Value>
          </LabelValueContainer>
          <LabelValueContainer>
            <Label>{labels[store.currentLanguage].form.adressline}</Label>
            <Value>{user?.address}</Value>
          </LabelValueContainer>
        </ColumnContainer>

        <div style={{ alignSelf: 'stretch' }}>
          <LanguageContainer >
            <Label>{labels[store.currentLanguage].form.langselector}</Label>
            <FlagsContainer>
              {flagItems}
            </FlagsContainer>
          </LanguageContainer>

          <Button style={{ margin: 'auto', marginTop: '20px' }} title={labels[store.currentLanguage].button.loggout} callback={signOut} />
        </div >

      </MainContainer>
    </div>
  )
})

export default ProfilePage;